import { getEvent } from 'client/api/booking-calendar-api'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import EntityExampleWrapperNew from 'client/components/core/EntityExampleWrapper/EntityExampleWrapperNew'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import useSettingsManagement, { selectors } from 'client/hooks/useManagement'
import { useManagement, usePage } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import pageSelectors from 'client/store/page/pageSelectors'
import { EntityProps } from 'client/types'
import CommonBookingCalendar from 'common/components/entities/Calendar'
import { EventTimeZoneTypeEnum } from 'common/components/entities/Calendar/constants'
import { useEvent } from 'common/components/entities/Calendar/hooks/use-event'
import { BookingCalendarInterface } from 'common/types/entities/BookingCalendarInterface'
import { getLocalTimeZone } from 'common/utils/date-utils'
import React from 'react'
import { mockBooking } from './mock-booking'
import { useTypography } from 'src/editor/shared/hooks/use-typography'

export const BookingCalendar = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BookingCalendarInterface>) => {
  const activeStep = useSettingsManagement(selectors.getBookingCalendarStepType)
  const { isMobile } = useDeviceModeContext()

  const {
    calculatedFontSize,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useTypography()

  const userTimeZone = useManagement(managementSelectors.getUserTimezone)

  const { event, isFetching } = useEvent({
    eventId: entity.eventId,
    fetcher: getEvent,
  })

  const selectedTimeZone =
    event?.displayTimezoneType === EventTimeZoneTypeEnum.Local
      ? userTimeZone
      : event?.displayTimezone || getLocalTimeZone()

  const hasThankYouStepButton = !!(
    entity?.thankYouStepButtonType && entity?.thankYouStepButtonType !== 'none'
  )
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <EntityExampleWrapperNew
        visible={!entity?.eventId}
        label="entities.calendar.example_warning"
      >
        <CommonBookingCalendar
          selectedDate={mockBooking.selectedDate}
          selectedTimeSlot={mockBooking.selectedTimeSlot}
          selectedLocationId={event?.locations?.[0]?.id}
          selectedTimeZone={selectedTimeZone ?? getLocalTimeZone()}
          isLoading={isFetching}
          isMobile={isMobile}
          availabilitySlots={mockBooking.availabilitySlots}
          event={event}
          fontSize={calculatedFontSize.desktop}
          mobileFontSize={calculatedFontSize.mobile}
          fontFamily={calculatedFontFamily.desktop}
          mobileFontFamily={calculatedFontFamily.mobile}
          activeStep={activeStep}
          entity={entity}
          hasThankYouStepButton={hasThankYouStepButton}
          formStepChildren={
            <ChildrenEntities
              id={entity.id}
              childIds={entity.childIds as never[]} // we need to migrate ChildrenEntities to ts to avoid
              type={entity.type}
            />
          }
        />
      </EntityExampleWrapperNew>
    </BaseEntityNew>
  )
}
